function cleanDescription(originalDescription = '') {
  if (!originalDescription) {
    return '';
  }
  const realSpacesDescription = originalDescription.replace(/&nbsp;/g, ' ');
  const stripedDescription = realSpacesDescription.replace(/(<([^>]+)>)/ig, '');
  if (stripedDescription.length > 200) {
    return `${stripedDescription.substring(0, 196)}...`;
  }
  return stripedDescription;
}

export default cleanDescription;



// WEBPACK FOOTER //
// ./public/js/utils/cleanDescription.js